import Swiper from 'swiper/bundle';

// Exposed globally so pattern-cropper's direct cart/add AJAX can call
// the same init logic — without this, products that open the cropper
// (which bypasses productCartAdd) showed the upsell rail as 1 huge
// slide because no JS was wiring the Swiper after the modal opened.
window.initCartModalUpsells = function () {
    var cartModalEl = document.getElementById('cartModal');
    if (!cartModalEl) return;

    // Strip data-swiper so the global initSwipers() pass can't break
    // our modal swipers (an unrelated malformed [data-swiper] elsewhere
    // on the page can throw mid-loop and leave them un-initialised).
    cartModalEl.querySelectorAll('.cart-modal-upsells [data-swiper]')
        .forEach(function (el) {
            el.removeAttribute('data-swiper');
            var wrap = el.closest('.cart-modal-upsells');
            if (wrap) {
                wrap.style.overflowX = 'hidden';
                wrap.style.maxWidth = '100%';
            }
            el.style.overflow = 'hidden';
        });

    function initSwipersOnce(reason) {
        var els = cartModalEl.querySelectorAll('.cart-modal-upsells .swiper');
        console.log('[cart-modal-upsells] init attempt:', reason, 'swipers found:', els.length);
        els.forEach(function (el) {
            if (el.swiper) { return; }
            try {
                new Swiper(el, {
                    slidesPerView: 2.2,
                    slidesPerGroup: 2,
                    spaceBetween: 12,
                    freeMode: false,
                    autoplay: false,
                    loop: false,
                    observer: true,
                    breakpoints: {
                        768: { slidesPerView: 2.2, slidesPerGroup: 2, spaceBetween: 16 },
                        992: { slidesPerView: 2.2, slidesPerGroup: 2, spaceBetween: 20 }
                    }
                });
                console.log('[cart-modal-upsells] Swiper instantiated');
            } catch (e) {
                console.error('[cart-modal-upsells] Swiper failed:', e);
            }
        });
    }

    // Triple-strategy: shown.bs.modal event + setTimeout fallback,
    // because some themes don't propagate bs events reliably.
    cartModalEl.addEventListener('shown.bs.modal', function () {
        initSwipersOnce('shown.bs.modal');
    });
    setTimeout(function () { initSwipersOnce('setTimeout-800ms'); }, 800);
};

// Parse an option-price string that may come in any locale: "21,28 lei",
// "21.28 lei", "1.234,56", "1,234.56", etc. The old parser did
// .replace('.', '').replace(/^.*?(\d+(\.\d+)?).*?$/, "$1") which assumed
// '.' as decimal and dropped everything after the comma — so "21,28 lei"
// became 21 instead of 21.28, and 39.52 + 21 rendered as 60.52 on the PDP
// instead of the correct 60.80. This helper detects the decimal separator
// from whichever of ',' or '.' appears last, strips thousand separators,
// then parseFloats.
function parseOptionPrice(s) {
    s = String(s == null ? '' : s).replace(/[^\d.,-]/g, '');
    if (!s) return 0;
    // The last separator is the decimal one only when exactly two digits follow it ("21,28", "1,234.50");
    // otherwise every separator groups thousands ("1.234 lei" since whole prices lost their ",00").
    var m = s.match(/^(.*?)[.,](\d{2})$/);
    s = m ? m[1].replace(/[.,]/g, '') + '.' + m[2] : s.replace(/[.,]/g, '');
    var v = parseFloat(s);
    return isNaN(v) ? 0 : v;
}

window.getPriceForSelectedOptions = function (type = 'price') {
    const priceElement = $('[name="price_value"]');
    let price = 0;
    if (type === 'price') {
        price = parseFloat(priceElement.val().replace(/^.*?(\d+(\.\d+)?).*?$/, "$1"));
    }
    if (type === 'price-val') {
        price = parseFloat($('[data-price-val]').data('price-val'));
    }
    if (type === 'special-val') {
        price = parseFloat($('[data-special-val]').data('special-val'));
    }

    // Options flagged data-option-discount follow the same percentage as the special price
    // (special / base). The struck-through original price keeps full option prices.
    let specialRatio = 1;
    if (type !== 'price-val') {
        const specialBase = parseFloat($('[data-special-val]').data('special-val'));
        const originalBase = parseFloat($('[data-price-val]').data('price-val'));
        if (specialBase > 0 && originalBase > 0) specialRatio = specialBase / originalBase;
    }
    const optionDelta = function ($el, delta) {
        return $el.data('option-discount') == 1 ? delta * specialRatio : delta;
    };

    $('select[name*="option"]').each(function () {
        let operation = $(this).find('option:selected').data('option-price-prefix');
        let o_price = $(this).find('option:selected').data('option-price');
        if (o_price && operation) {
            const delta = optionDelta($(this).find('option:selected'), parseOptionPrice(o_price));
            if (operation === '+') price += delta;
            else if (operation === '-') price -= delta;
        }
    });
    $('input[name*="option"][type="radio"]:checked').each(function () {
        let operation = $(this).data('option-price-prefix');
        let o_price = $(this).data('option-price');
        if (o_price && operation) {
            const delta = optionDelta($(this), parseOptionPrice(o_price));
            if (operation === '+') price += delta;
            else if (operation === '-') price -= delta;
        }
    });
    $('input[name*="option"][type="checkbox"]:checked').each(function () {
        let operation = $(this).data('option-price-prefix');
        let o_price = $(this).data('option-price');
        if (o_price && operation) {
            const delta = optionDelta($(this), parseOptionPrice(o_price));
            if (operation === '+') price += delta;
            else if (operation === '-') price -= delta;
        }
    });

    return price;
}
window.optionChanged = function () {
    calculatePriceAndQuantity();
    updateModel();
}
window.updateModel = function () {
    let model = $model;

    $('select[name*="option"] option:selected, input[name*="option"][type="radio"]:checked, input[name*="option"][type="checkbox"]:checked').each(function () {
        const model_part = $(this).data('ciopmodel');
        if (model_part) {
            model += model_part;
        }
    });
    $('#product-model').html(model);

}
// Same format as the server (price_block.tpl): "179 lei", "125,30 lei"; whole amounts without ",00".
function formatProductPrice(value) {
    const rounded = Math.round(parseFloat(value) * 100) / 100;
    const decimals = Number.isInteger(rounded) ? 0 : 2;
    const currency = window.CURRENCY_CODE || 'RON';
    if (currency === 'RON') {
        return new Intl.NumberFormat('ro-RO', {minimumFractionDigits: decimals, maximumFractionDigits: decimals}).format(rounded) + ' lei';
    }
    return new Intl.NumberFormat('ro-RO', {style: 'currency', currency: currency, minimumFractionDigits: decimals, maximumFractionDigits: decimals}).format(rounded);
}
window.calculatePriceAndQuantity = function () {
    const virtualQuantityEl = $('[name="virtual_quantity"]');
    const priceValEl = $('[data-price-val]');
    const specialValEl = $('[data-special-val]');
    const priceSqmEl = $('[data-price-sqm]');
    const specialSqmEl = $('[data-special-sqm]');

    let selected_quantity = 1;
    if (virtualQuantityEl.length) {
        selected_quantity = $('[name="virtual_quantity"]').val();
    }
    let quantity = Math.max($product_minimum, selected_quantity);
    if ($option_densitate_id != '0') {
        const optionLengthElement = $(optionLengthElementSelector);

        if (optionLengthElement.length === 0) {
            return false;
        }

        quantity = parseInt(optionLengthElement.val()) / 100;
    } else if ($option_height_id != '0' && $option_width_id != '0') {
        const optionHeightElement = $('#input-option' + $option_height_id);
        const optionWidthElement = $('#input-option' + $option_width_id);

        if (optionHeightElement.length === 0 || optionWidthElement.length === 0) {
            return 0;
        }

        const _w = parseFloat(optionWidthElement.val()) || 0;
        const _h = parseFloat(optionHeightElement.val()) || 0;
        const _divisor = (typeof $dim_unit !== 'undefined' && $dim_unit === 'mm') ? 1000000 : 10000;
        quantity = Math.max($product_minimum, _w * _h / _divisor);
    }
    if (isNaN(quantity)) {
        quantity = Math.max($product_minimum, selected_quantity);
    }
    //quantity = Math.max(1, quantity);

    if (priceValEl.length) {
        priceValEl.text(formatProductPrice(getPriceForSelectedOptions('price-val')));
    }
    if (specialValEl.length) {
        specialValEl.text(formatProductPrice(getPriceForSelectedOptions('special-val')));
    }
    if (priceSqmEl.length) {
        priceSqmEl.text(formatProductPrice(getPriceForSelectedOptions('price-val') / parseFloat(priceSqmEl.data('price-sqm'))));
    }
    if (specialSqmEl.length) {
        specialSqmEl.text(formatProductPrice(getPriceForSelectedOptions('special-val') / parseFloat(specialSqmEl.data('special-sqm'))));
    }

    // Products shown without a price (e.g. some xtwalls panels) have no [name="price_value"]: stop here,
    // where the old code stopped with a TypeError on .val().replace() at every page load.
    if (!$('[name="price_value"]').length) {
        return;
    }
    const price = getPriceForSelectedOptions();
    $('#calculated-quantity').text(parseFloat(quantity).toFixed(2));
    if (virtualQuantityEl.length) {
        virtualQuantityEl.val(parseInt(quantity));
    }
    $('[name="quantity"]').val(parseFloat(quantity).toFixed(2));
    $('#calculated-price').text(formatProductPrice(quantity.toFixed(2) * price));
}
window.productCartAdd = function (data = null) {
    if (!data) {
        data = $('#product input[type=\'text\'], #product input[type=\'number\'], #product input[type=\'hidden\'], #product input[type=\'radio\']:checked, #product input[type=\'checkbox\']:checked, #product select, #product textarea');
    }
    customAjaxRequest('index.php?route=checkout/cart/add', 'post', data, function () {
    }, function (json) {
        if (typeof timer != 'undefined') {
            clearTimeout(timer);
        }
        $('.alert, .invalid-feedback').remove();
        $('.is-invalid').removeClass('is-invalid');

        if (json['error']) {
            if (json['error']['option']) {
                for (i in json['error']['option']) {
                    var element = $('#input-option' + i.replace('_', '-'));

                    if (element.parent().hasClass('input-group')) {
                        element.addClass('is-invalid').parent().after('<div class="invalid-feedback">' + json['error']['option'][i] + '</div>');
                    } else {
                        element.addClass('is-invalid').after('<div class="invalid-feedback">' + json['error']['option'][i] + '</div>');
                    }
                }
            }

            if (json['error']['quantity']) {
                alertMessage('pink-dark', 'exclamation-circle', json['error']['quantity'])
            }
        }

        if (json['success']) {
            // Reîncărcarea lui #cart distruge elementul modalului, care stă
            // înăuntrul lui — vezi window.reloadCartAndShowModal în helper.js.
            window.reloadCartAndShowModal();
        }
        // window.: an undeclared timer = ... throws "timer is not defined" in the strict-mode bundle (2026-11-01)
        window.timer = setTimeout(function () {
            $('.alert').addClass('fadeOut');
        }, 4000)
    });
}
window.productSampleAdd = function (json_string) {
    const ciopmodel = $('input[data-ciopmodel^="-"]:checked').data('ciopmodel');
    let json = JSON.parse(json_string.replaceAll("'", '"'));
    if (typeof ciopmodel !== 'undefined') {
        json.option['17734'] = json.option['17734'] + ciopmodel;
    }

    productCartAdd(json);
}
window.calculateRolaPerInput = function () {
    const rola_width = parseFloat($rola_width);
    const rola_height = parseFloat($rola_height);
    const input_width = parseFloat($('#input-rola-calculator-width').val()) / 100;
    const input_height = parseFloat($('#input-rola-calculator-height').val()) / 100;
    const quantity = Math.ceil(((input_width * input_height) * 1.3) / (rola_width * rola_height));
    if (quantity) {
        $('#rola-calculation-result').html('necesar: <b>' + quantity + '</b>');
    } else {
        $('#rola-calculation-result').html('introdu mai sus');
    }
    return quantity;
}
window.inputStep = function (el) {
    const stepAttr = el.attr('step');
    if (!stepAttr || stepAttr === 'any') return; // decimals allowed — nothing to round
    const step = parseInt(stepAttr);
    if (isNaN(step) || step <= 0) return;
    const d = el.val() % step;
    if (d > 0) {
        el.val(parseInt(el.val()) + step - d);
    }
}

window.createProductReview = function (product_id) {
    const url = 'index.php?route=product/product/write&product_id=' + product_id;
    customAjaxRequest(url, 'post', $("#form-review").serialize(), function () {
    }, function (json) {
        $('.alert').remove();

        if (json['error']) {
            $('#form-review').before('<div class="alert alert-pink"><i class="fa fa-exclamation-circle"></i> ' + json['error'] + '</div>');
        }

        if (json['success']) {
            $('#button-review').remove();
            $('#reviewsFormModalLabel').html('Recepționat');
            $('#form-review').replaceWith('<p>' + json['success'] + '</p>');
        }
    });
}
window.pad = function (number) {
    return number < 10 ? '0' + number : number;
}

$(document).ready(function () {
    if ($('body').hasClass('product-product')) {
        if ($option_densitate_id != '0') {
            const inaltimeElement = $(optionInaltimeElementSelector);
            inaltimeElement.attr('max', inaltimeElement.val());
            inaltimeElement.attr('min', 1)

            $(inaltimeElement).change(function () {
                const max = parseInt($(this).attr('max'));
                if (parseInt($(this).val()) > max) {
                    $(this).val(max);
                }
                if (parseInt($(this).val()) < 1) {
                    $(this).val(1);
                }
            });
        }


        $('input[type="number"][step][name*="option"]').change(function () {
            inputStep($(this));
        });

        $('select[name*="option"]').change(function () {
            const text_value = $(this).find('option:selected').text();
            // TresTintas (44) is exempt from the material-strip width-step hint —
            // Adrian Grigore, 2026-10-21 (options.tpl already exempts it from the
            // manufacturer-level restriction; this material-name-driven one is
            // separate and used by several other manufacturers, so it's gated
            // here instead of removed).
            if (typeof $manufacturer_id !== 'undefined' && parseInt($manufacturer_id) === 44) {
                return;
            }
            if (text_value.indexOf('@') > -1) {
                const tvp = text_value.split('@');
                if (tvp[1]) {
                    const tvp2 = tvp[1].split('cm');
                    const stepVal = parseInt(tvp2[0]);
                    const inputEl = $('input[type="number"][name*="option"][placeholder*="Lățime"]');
                    // Set step and min based on material, then clamp current value
                    inputEl.attr('step', stepVal).attr('min', stepVal);
                    if (isNaN(parseInt(inputEl.val())) || parseInt(inputEl.val()) < stepVal) {
                        inputEl.val(stepVal);
                    } else {
                        inputStep(inputEl); // round current value up to nearest step
                    }
                    // Wrap input in input-group with +/- buttons (only once)
                    if (!inputEl.parent().hasClass('width-step-group')) {
                        inputEl.wrap('<div class="input-group width-step-group"></div>');
                        inputEl.before('<button type="button" class="btn btn-outline-secondary width-btn-minus" tabindex="-1">−</button>');
                        inputEl.after('<button type="button" class="btn btn-outline-secondary width-btn-plus" tabindex="-1">+</button>');
                    }
                    // Update step data on buttons so clicks always use current stepVal
                    inputEl.parent().data('step', stepVal);

                    // Minus button
                    inputEl.parent().off('click.widthbtn').on('click.widthbtn', '.width-btn-minus, .width-btn-plus', function () {
                        const s = inputEl.parent().data('step');
                        const cur = parseInt(inputEl.val()) || 0;
                        const min = parseInt(inputEl.attr('min')) || s;
                        const dir = $(this).hasClass('width-btn-plus') ? 1 : -1;
                        const next = Math.max(min, cur + dir * s);
                        inputEl.val(next).trigger('change');
                    });

                    // Show helper hint below the input-group
                    const hintId = 'width-step-hint';
                    let hint = $('#' + hintId);
                    if (!hint.length) {
                        hint = $('<small id="' + hintId + '" class="form-text mt-4"></small>');
                        inputEl.parent().after(hint);
                    }
                    hint.html('Folosiți <strong>+ / −</strong> pentru a selecta lățimea în pași de <strong>' + stepVal + ' cm</strong>');

                    // Validate on input: warn if value is not a multiple of step
                    inputEl.off('input.stepcheck').on('input.stepcheck', function () {
                        const val = parseInt($(this).val());
                        if (val > 0 && val % stepVal !== 0) {
                            $(this).addClass('is-invalid');
                            hint.addClass('text-danger').removeClass('text-muted');
                        } else {
                            $(this).removeClass('is-invalid');
                            hint.removeClass('text-danger').addClass('text-muted');
                        }
                    });
                    hint.addClass('text-muted').removeClass('text-danger');
                    inputEl.removeClass('is-invalid');
                    // optionChanged (line below) fires after this handler completes
                    // and will recalculate sqm with the updated width value
                }
            }
        });

        $('select[name*="option"]').on("change", optionChanged);
        $('input[name*="option"][type="radio"]').on("change", optionChanged);
        $('input[name*="option"][type="checkbox"]').on("change", optionChanged);
        $('input[name*="option"][type="text"]').on("input", optionChanged);
        $('input[name*="option"][type="textarea"]').on("input", optionChanged);
        $('input[name*="option"][type="number"]').on("input change", function () {
            const inputEl = $(this);
            let val = parseFloat(inputEl.val());
            const min = parseFloat(inputEl.attr('min'));
            const max = parseFloat(inputEl.attr('max'));

            if (!isNaN(max) && val > max) {
                val = max;
            }

            if (!isNaN(min) && val < min) {
                val = min;
            }

            inputEl.val(val);
        });
        $('input[name*="option"][type="number"]').on("input change", optionChanged);

        calculatePriceAndQuantity();

        $('#input-rola-calculator-width, #input-rola-calculator-height').on('input change', calculateRolaPerInput);

        $('#rola-calculator-add-to-cart').click(function () {
            const quantity = calculateRolaPerInput();
            if (quantity) {
                $('[name="virtual_quantity"]').val(quantity);
                $('[name="quantity"]').val(quantity);
                productCartAdd();
                $('#rolaCalculatorModal').modal('hide');
            }
        });

        $('[name="virtual_quantity"]').on("change", function () {
            const quantity = $(this).val();
            $('[name="quantity"]').val(quantity);
        });

        if ($show_review_modal == '1') {
            $('[data-bs-target="reviewsFormModal"]').click();
        }

        const firstRal = $('.rounded-circle[style*="aspect-ratio"]').first();
        const htmlSample = $('.sample-product-image__background');
        if (htmlSample.length && firstRal.length) {
            htmlSample.css('background-color', firstRal.css('background-color'))
        }

        if ($special_expire != '0') {
            const endDate = new Date($special_expire);

            function updateTimer() {
                const ts = countdown(null, endDate, countdown.HOURS | countdown.MINUTES | countdown.SECONDS, 3);
                console.log(ts);
                document.getElementById('special-countdown-hours').innerHTML = pad(ts.hours);
                document.getElementById('special-countdown-minutes').innerHTML = pad(ts.minutes);
                document.getElementById('special-countdown-seconds').innerHTML = pad(ts.seconds);
                if (ts.value <= 0) {
                    location.reload();
                }
            }

            setInterval(updateTimer, 1000);
            updateTimer()
        }

        // On is_mto products, if there's a Material option (select or radio)
        // with at least one zero-priced value, auto-select the first such
        // value so the customer isn't blocked by a "please choose a material"
        // validation when the default option is free.
        autoSelectMaterialOption();
    }
});

/**
 * Auto-select a sensible default for a "Material" option on MTO products.
 *
 * Rule:
 *   * Only runs when $is_mto is truthy (set in product.tpl from the
 *     controller-side $product_info['is_mto']).
 *   * Finds option groups inside #product whose label text contains
 *     the word "material" (case-insensitive).
 *   * If the customer/server hasn't already picked a value, picks the
 *     FIRST value with data-option-price = 0. If every value has a
 *     non-zero added price, leaves the option un-selected so the
 *     customer makes the call.
 *   * Fires `change` so the existing optionChanged() handler recomputes
 *     price/model.
 */
window.autoSelectMaterialOption = function () {
    if (typeof $is_mto === 'undefined' || !$is_mto) return;

    const labels = document.querySelectorAll('#product label.form-label');
    labels.forEach(function (label) {
        if (!/\bmaterial\b/i.test(label.textContent)) return;

        const forAttr = label.getAttribute('for');
        if (!forAttr) return;
        const control = document.getElementById(forAttr);
        if (!control) return;

        const tag = control.tagName.toUpperCase();

        if (tag === 'SELECT') {
            // Skip if a value is already picked (server-side `selected` or
            // browser-restored).
            if (control.value && control.value !== '') return;
            const opts = control.querySelectorAll('option[data-option-price]');
            for (let i = 0; i < opts.length; i++) {
                const price = parseFloat(opts[i].getAttribute('data-option-price') || '0') || 0;
                if (price === 0) {
                    control.value = opts[i].value;
                    control.dispatchEvent(new Event('change', { bubbles: true }));
                    return;
                }
            }
            return;
        }

        // Otherwise it's a radio container <div id="input-optionX">. Skip
        // if a radio is already checked.
        if (control.querySelector('input[type="radio"]:checked')) return;
        const radios = control.querySelectorAll('input[type="radio"][data-option-price]');
        for (let i = 0; i < radios.length; i++) {
            const price = parseFloat(radios[i].getAttribute('data-option-price') || '0') || 0;
            if (price === 0) {
                radios[i].checked = true;
                radios[i].dispatchEvent(new Event('change', { bubbles: true }));
                radios[i].dispatchEvent(new Event('click',  { bubbles: true }));
                return;
            }
        }
    });
};
